export const ROOT_PATH = "";

// 認証系
export const LOGIN_PATH = `${ROOT_PATH}/auth/login`;
export const SIGNUP_PATH = `${ROOT_PATH}/auth/signup`;
export const PASSWORD_RESET_PATH = `${ROOT_PATH}/auth/password-reset`;
// カラーミーショップ OAuth ログイン
export const COLORME_LOGIN_PATH = `${ROOT_PATH}/auth/colorme`;
export const COLORME_CALLBACK_PATH = `${ROOT_PATH}/auth/colorme-callback`;
// カラーミーショップ アプリストアからのインストール成功画面（未ログインでも開く）
export const COLORME_INSTALLED_PATH = `${ROOT_PATH}/colorme/installed`;

// ダッシュボード
export const DASHBOARD_PATH = `${ROOT_PATH}/dashboard`;

// KPI設定（目標シート）
export const KPI_GOAL_PATH = `${ROOT_PATH}/kpi-goal`;

// マイアカウント
export const MYACCOUNT_INSIGHT_PATH = `${ROOT_PATH}/myaccount/insight`;
export const MYACCOUNT_BREAKDOWN_PATH = `${ROOT_PATH}/myaccount/breakdown`;
export const MYACCOUNT_FOLLOWER_TYPE_PATH = `${ROOT_PATH}/myaccount/follower-type`;

// 投稿一覧, ストーリーズ一覧, 初速分析系
export const POST_GENERATOR_PATH = `${ROOT_PATH}/post-generator`;
export const TABLE_FIRST_POST = `${ROOT_PATH}/table/first-feed-post`;
export const TABLE_FEED_PATH = `${ROOT_PATH}/table/feed-post`;
export const TABLE_REEL_FIRST_POST = `${ROOT_PATH}/table/first-reel-post`;
export const TABLE_REEL_PATH = `${ROOT_PATH}/table/reel-post`;
export const TABLE_STORIES_PATH = `${ROOT_PATH}/table/stories`;
export const POST_MEDIA_CALENDAR_PATH = `${ROOT_PATH}/table/post-media-calendar`;

// ハッシュタグ系
export const HASHTAG_PERFORMANCE_PATH = `${ROOT_PATH}/hashtag/performance`;
export const HASHTAG_GROUP_PERFORMANCE_PATH = `${ROOT_PATH}/hashtag/group-performance`;
export const HASHTAG_RECOMMEND_PATH = `${ROOT_PATH}/hashtag/recommend`;
export const HASHTAG_RESEARCH_PATH = `${ROOT_PATH}/hashtag/research`;

// ベンチマーク系
export const BENCHMARK_SETTINGS_PATH = `${ROOT_PATH}/benchmark/benchmark-settings`;
export const BENCHMARK_INSIGHT_PATH = `${ROOT_PATH}/benchmark/benchmark-insight`;
export const BENCHMARK_FEED_MEDIA_PATH = `${ROOT_PATH}/benchmark/benchmark-feed-media`;
export const BENCHMARK_HASHTAG_PATH = `${ROOT_PATH}/benchmark/benchmark-hashtag`;
// benchmark-revamp: 新IA (4メニュー = インサイト(着地)/投稿一覧/レポート/設定)
// インサイトが着地 (横断AI解説+KPI/ランキング+各社深掘り導線+推移)。空なら設定への導線を表示。
// 競合比較Excelレポート (benchmark-report)
export const BENCHMARK_REPORT_PATH = `${ROOT_PATH}/benchmark/benchmark-report`;
// 競合1社の深掘りはインサイトの「各アカウントごと」タブ(BenchmarkAccountBriefing)に集約。
// 設定の「詳細を見る」/トグルから ?account= 付きで遷移する。

// コメント管理
export const MANAGE_COMMENT = `${ROOT_PATH}/comment`;

// ファン
export const FAN_PATH = `${ROOT_PATH}/mention`;

// コンテンツ系
export const POST_RESERVATION_PATH = `${ROOT_PATH}/contents/post-reservation`;
export const CONTENTS_LIBRARY_PATH = `${ROOT_PATH}/contents/contents-library`;

// レポート系
export const REPORT_TEMPLATE = `${ROOT_PATH}/report/template`;
export const REPORT_DOWNLOAD_LIST = `${ROOT_PATH}/report/download-list`;

// AI機能
export const AI_REPORT_ANALYSIS_PATH = `${ROOT_PATH}/ai/report-analysis`;

// 広告管理（HN-AD-AUTO-01）
export const ADS_PATH = `${ROOT_PATH}/ads`;
export const ADS_ACCOUNTS_PATH = `${ROOT_PATH}/ads/accounts`;
export const ADS_CAMPAIGNS_PATH = `${ROOT_PATH}/ads/campaigns`;
export const ADS_CREATE_PATH = `${ROOT_PATH}/ads/create`;

// マイページ、設定系
export const MYPAGE_PATH = `${ROOT_PATH}/mypage`;
export const MYPAGE_ACCOUNT_INFO_PATH = `${ROOT_PATH}/mypage/account-info`;
export const MYPAGE_INSTAGRAM_ACCOUNT_PATH = `${ROOT_PATH}/mypage/instagram-account`;
export const MYPAGE_RESET_MAIL_PATH = `${ROOT_PATH}/mypage/reset-mailaddress`;
export const MYPAGE_RESET_PASS_PATH = `${ROOT_PATH}/mypage/reset-password`;
export const MYPAGE_FACEBOOK_LINKED_PATH = `${ROOT_PATH}/mypage/facebook-linked`;
export const MYPAGE_COLORME_LINKED_PATH = `${ROOT_PATH}/mypage/colorme-linked`;
export const MYPAGE_PLAN_INFO_PATH = `${ROOT_PATH}/mypage/plan-info`;
export const MYPAGE_CAMPAIGN_PATH = `${ROOT_PATH}/mypage/campaign`;
export const MYPAGE_WITHDRAW_PATH = `${ROOT_PATH}/mypage/withdraw`;
// 法人ダッシュボードだけで使う(所属組織の確認と切替)
export const MYPAGE_ORGANIZATION_PATH = `${ROOT_PATH}/mypage/organization`;

// アップグレードプラン
export const PLAN_PATH = `${ROOT_PATH}/plan`;
